export enum SubmissionMethod {
  API = "api",
  EMAIL = "email",
  MANUAL = "manual",
  LENDFLOW = "lendflow",
}
